import { useRef } from 'react';

import { useTranslation } from 'react-i18next';

import DialogBox from '~/components/DialogBox';

type Props = {
    openDialog: boolean;
    setOpenDialog: (arg: boolean) => void;
    dialogValidation: { hashChange: boolean; noteDuplicate: boolean };
    hasOwnApplicantNotes: { applicant1: boolean; applicant2: boolean };
    setDialogValidation: (arg: { hashChange: boolean; noteDuplicate: boolean }) => void;
};

export const HashDialog: React.FC<Props> = ({
    dialogValidation,
    hasOwnApplicantNotes,
    openDialog,
    setDialogValidation,
    setOpenDialog,
}) => {
    const { t } = useTranslation();
    const initialFocusRef = useRef<HTMLDivElement>(null);

    return (
        <DialogBox
            title={
                <div className="flex items-center gap-2">
                    <h6 className="text-base font-semibold text-grey">{t('PERSONAL_DATA.DIALOG.TITLE')}</h6>
                </div>
            }
            open={openDialog && (hasOwnApplicantNotes.applicant1 || hasOwnApplicantNotes.applicant2)}
            onClose={() => {
                setOpenDialog(false);
            }}
            initialFocusRef={initialFocusRef}
        >
            {!dialogValidation.hashChange && (
                <div className="bg-white w-full h-full my-3">
                    <div className="p-3 bg-grey-light w-full">
                        <p className="mb-1 text-xs font-medium text-grey">
                            {t('PERSONAL_DATA.DIALOG.INFO_HASH_CHANGE')}
                        </p>
                    </div>
                    <div className="flex justify-end gap-2 pt-2 ">
                        <button
                            className="inline-flex items-center px-3 py-2 space-x-2 text-sm text-white bg-stone-300"
                            onClick={() => {
                                setDialogValidation({ ...dialogValidation, hashChange: false });
                                setOpenDialog(false);
                            }}
                        >
                            {t('BUTTONS.CANCEL')}
                        </button>
                        <button
                            className="inline-flex items-center px-3 py-2 space-x-2 text-sm text-white bg-green"
                            onClick={() => {
                                setDialogValidation({ ...dialogValidation, hashChange: true });
                            }}
                        >
                            {t('PERSONAL_DATA.DIALOG.BUTTONS.CONFIRM')}
                        </button>
                    </div>
                </div>
            )}
            {dialogValidation.hashChange && (
                <div className="bg-white w-full h-full my-3">
                    <div className="p-3 bg-grey-light w-full">
                        <p className="mb-1 text-xs font-medium text-grey">
                            {t('PERSONAL_DATA.DIALOG.DUPLICATE_APPLICANT_NOTE')}
                        </p>
                    </div>
                    <div className="flex justify-end gap-2 pt-2">
                        <button
                            className="inline-flex items-center px-3 py-2 space-x-2 text-sm text-white bg-stone-300"
                            onClick={() => {
                                setDialogValidation({ ...dialogValidation, noteDuplicate: true });
                                setOpenDialog(false);
                            }}
                        >
                            {t('PERSONAL_DATA.DIALOG.BUTTONS.NO')}
                        </button>
                        <button
                            className="inline-flex items-center px-3 py-2 space-x-2 text-sm text-white bg-green"
                            onClick={() => {
                                setDialogValidation({ ...dialogValidation, noteDuplicate: false });
                                setOpenDialog(false);
                            }}
                        >
                            {t('PERSONAL_DATA.DIALOG.BUTTONS.YES')}
                        </button>
                    </div>
                </div>
            )}
        </DialogBox>
    );
};
